// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/calculators-personalloans-amortisation/calculators-personalloans-amortisation.component.scss
// module id = 799
// module chunks = 0